import api from '../api';

// ✅ INTERFACE ATUALIZADA - FASE 2: Sem campo foto_perfil
// ✅ CARGOS ATUALIZADOS: 4 cargos ativos (SEM legados)
export interface Usuario {
  id?: string;
  nome: string;
  usuario: string;
  email: string;
  senha?: string;
  cargo: 'admin' | 'psicologo' | 'estudante' | 'atendente';
  cod_empresa: number;
  ativo: boolean;
  crp?: string;
  telefone?: string;
  foto_perfil_storage_key?: string; // ✅ ÚNICO campo para foto - Oracle Storage key
  createdAt?: string;
  ultimo_login?: string;
}

export const usuariosService = {
  listarUsuarios: async (): Promise<Usuario[]> => {
    const response = await api.get<Usuario[]>('/usuarios');
    return response.data;
  },

  obterUsuario: async (id: string): Promise<Usuario> => {
    console.log('🎯 usuariosService.obterUsuario chamado com ID:', id, typeof id);
    const response = await api.get<Usuario>(`/usuarios/${id}`);
    console.log('🎯 usuariosService.obterUsuario response:', response.data);
    return response.data;
  },

  criarUsuario: async (usuario: Usuario): Promise<Usuario> => {
    const response = await api.post<Usuario>('/usuarios', usuario);
    return response.data;
  },
  
  criarUsuarioComFoto: async (usuario: Usuario, foto: File): Promise<Usuario> => {
    const formData = new FormData();
    
    // Adicionar o arquivo
    formData.append('foto_perfil', foto);
    
    // Adicionar os demais campos
    Object.keys(usuario).forEach(key => {
      const value = usuario[key as keyof Usuario];
      // Add null/undefined check before converting to string
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });
    
    const response = await api.post<Usuario>('/usuarios', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  criarUsuarioComArquivo: async (formData: FormData): Promise<Usuario> => {
    try {
      console.log('[UsuariosService] Criando usuário com upload de arquivo');
      
      const response = await api.post<Usuario>('/usuarios', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 30000
      });
      
      console.log('[UsuariosService] Usuário criado com sucesso');
      return response.data;
    } catch (error) {
      console.error('[UsuariosService] Erro ao criar usuário:', error);
      throw error;
    }
  },

  atualizarUsuario: async (id: string, usuario: Partial<Usuario>): Promise<Usuario> => {
    const response = await api.put<Usuario>(`/usuarios/${id}`, usuario);
    return response.data;
  },
  
  atualizarUsuarioComFoto: async (id: string, usuario: Partial<Usuario>, foto: File): Promise<Usuario> => {
    const formData = new FormData();
    
    // Adicionar o arquivo
    formData.append('foto_perfil', foto);
    
    // Adicionar os demais campos
    Object.keys(usuario).forEach(key => {
      const value = usuario[key as keyof Partial<Usuario>];
      // Add null/undefined check before converting to string
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });
    
    const response = await api.put<Usuario>(`/usuarios/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  atualizarUsuarioComArquivo: async (id: string, formData: FormData): Promise<Usuario> => {
    try {
      console.log('[UsuariosService] Atualizando usuário com upload de arquivo:', id);
      
      const response = await api.put<Usuario>(`/usuarios/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 30000
      });
      
      console.log('[UsuariosService] Usuário atualizado com sucesso');
      return response.data;
    } catch (error) {
      console.error('[UsuariosService] Erro ao atualizar usuário:', error);
      throw error;
    }
  },

  alterarStatus: async (id: string, ativo: boolean): Promise<void> => {
    await api.put(`/usuarios/${id}/status`, { ativo });
  },

  resetarSenha: async (id: string): Promise<{ senha: string }> => {
    const response = await api.post<{ senha: string }>(`/usuarios/${id}/resetar-senha`);
    return response.data;
  },

  excluirUsuario: async (id: string): Promise<void> => {
    await api.delete(`/usuarios/${id}`);
  },
};
